import "core-js/modules/es.array.concat.js";
import React from 'react';
import styled from 'styled-components';
import { StarIcon } from '../Icons';
var Container = styled.div.withConfig({
  displayName: "Small__Container",
  componentId: "sc-cwv5ka-0"
})(["display:inline-block;height:22px;padding-left:3px;padding-right:7px;border:1px solid rgb(0 0 0 / 0.2);border-radius:", ";background-color:", ";span{padding-left:6px;vertical-align:top;font-size:12px;font-weight:500;line-height:20px;}svg{vertical-align:text-top !important;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.terciaryLL;
});
export var Small = function Small(_ref3) {
  var value = _ref3.value,
    reviews = _ref3.reviews;
  var qty = reviews;
  var color = value > 0 ? '#FFD552' : 'rgba(0, 0, 0, .5)';
  return React.createElement(Container, null, React.createElement(StarIcon, {
    width: 14,
    color: color
  }), qty === 0 ? React.createElement("span", null, "".concat(value || 0, " - ").concat(qty)) : React.createElement("span", null, "".concat(value || 0)));
};